const UserPermission = ({ name, description, defaultChecked, disabled, onChange, children }) => (
  <li>
    <label className="user-permission-option">
      <input
        type="radio"
        name="user-permission"
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={event => onChange && onChange(event)}
      />
      <div className="scope-detail">
        <span className="scope-detail-name">
          {name}
        </span>
        <p className="scope-detail-description">
          {description}
        </p>
      </div>
    </label>
    {children && (
      <label className="scope-advanced-options">
        {children}
      </label>
    )}
  </li>
)

export default UserPermission



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/EditUserRole/UserPermission.js